import { getSessionDuration } from 'application/session_duration'

export function viewModalEvent(data, clickModalLink) {
  window.dataLayer = window.dataLayer || []

  let arraySize = window.dataLayer.length
  let dataLayerIndex = null
  let forLoop = true
  let max = arraySize > 3 ? 3 : arraySize

  for (let i = 1; i < max; i++) {
    if (forLoop && window.dataLayer[arraySize - i].event == "modal_view") {
      dataLayerIndex = arraySize - i
      forLoop = false
    }
  }

  if (dataLayerIndex && window.dataLayer[dataLayerIndex].clickModalLink) { //check if previous view_modal event has clickModalLink param
    window.dataLayer.push({ clickModalLink: null }) //reset clickModalLink to prevent double view_modal push
  } else {
    window.dataLayer.push({
      event: "modal_view",
      clickModalLink: clickModalLink || null,
      session_duration: getSessionDuration(),
      module_name: data.module_name || '',
      click_text: data.click_text || '',
    });
  }
}
